<template>
  <div :class="classes(n())">
    <Popup
      :class="classes(n('actionsheet'))"
      :visible="visible"
      position="bottom"
      :close-on-click-overlay="true"
      teleport="body"
      @update:visible="onUpdateVisible"
      @clickOverlay="onClose"
    >
      <div :class="classes(n('actionsheet-content'))">
        <div v-if="title" :class="classes(n('actionsheet-content-title'))">
          {{ title }}
        </div>
        <div :class="classes(n('actionsheet-content-actions'))">
          <ActionSheetActionItem
            v-for="(item, index) in actions"
            :key="item.key"
            :class="classes(n('actionsheet-content-actions-item'))"
            :action="item"
            @click="onSelect(item, index)"
          />
        </div>
        <div
          :class="classes(n('actionsheet-content-cancel'))"
          role="button"
          :aria-label="cancelText || '取消'"
          @click="onCancel"
        >
          {{ cancelText || '取消' }}
        </div>
      </div>
    </Popup>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { props } from './props';
import { actionSheetEmits } from './emits';
import { createNamespace } from '../utils/components';
import Popup from '../popup/popup.vue';
import { ActionSheetAction } from './action-sheet';
import ActionSheetActionItem from './action-sheet-action-item.vue';

const { name, n, classes } = createNamespace('action-sheet');

export default defineComponent({
  name,
  components: { Popup, ActionSheetActionItem },
  props,
  emits: actionSheetEmits,
  setup(props, { emit }) {
    function onClose() {
      emit('update:visible', false);
      emit('close');
    }
    function onCancel() {
      emit('update:visible', false);
      emit('cancel');
    }
    function onSelect(selected: ActionSheetAction, index: number) {
      emit('update:visible', false);
      emit('select', selected, index);
    }
    function onUpdateVisible(visible: boolean) {
      emit('update:visible', visible);
    }
    return {
      n,
      classes,
      onClose,
      onCancel,
      onSelect,
      onUpdateVisible,
    };
  },
});
</script>
